<ng-container *ngIf="data.fields.Title.value !== ''">
  <div mat-dialog-title>
    <span class="dialog-title-label" *scText="data.fields.Title"></span>
    <button
      *ngIf="data.fields.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>
<div mat-dialog-content>
  <div class="list-numbered fixed-view">
    <ul>
      <li>
        <div>
          <span
            class="circle"
            *scText="items.chooseDevice.fields.stepNumber"
          ></span>
        </div>
        <div>
          <span *scRichText="items.chooseDevice.fields.stepText"></span>
          <mat-radio-group
            class="ab-radio-group mt--6"
            [(ngModel)]="otpType"
            (change)="radioChange()"
          >
            <mat-radio-button class="ab-radio" value="abopassValue">
              <span
                class="ml--3"
                *scText="formFields.fields.token.label"
              ></span>
            </mat-radio-button>
            <mat-radio-button
              class="ab-radio"
              value="mobilephoneValue"
              *ngIf="!data.approvalData || data.approvalData.isRetail"
            >
              <span class="ml--3" *scText="formFields.fields.app.label"></span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </li>
      <ng-container *ngIf="otpType === 'mobilephoneValue'">
        <li *ngFor="let item of items.app.fields.items; let i = index">
          <div>
            <span class="circle" *scText="item.fields.stepNumber"></span>
          </div>
          <div>
            <span *scRichText="item.fields.stepText"></span>
            <div class="challenge-code" *ngIf="i === 2">
              {{ challengeCode }}
            </div>
          </div>
        </li>
      </ng-container>
      <ng-container *ngIf="otpType === 'abopassValue'">
        <li *ngFor="let item of items.token.fields.items; let i = index">
          <div>
            <span class="circle" *scText="item.fields.stepNumber"></span>
          </div>
          <div>
            <span *scRichText="item.fields.stepText"></span>
            <div class="challenge-code" *ngIf="i === 3">
              {{ challengeCode }}
            </div>
          </div>
        </li>
      </ng-container>
    </ul>
    <form [hidden]="!otpType" [formGroup]="approvalForm">
      <div class="form-group w-50">
        <label *scText="formFields.fields.code.label"></label>
        <input
          class="form-control"
          type="tel"
          formControlName="approvalCode"
          maxlength="14"
          #approvalCodeInput
        />
        <span
          class="field-validation-error"
          *ngIf="approvalCode.errors?.required"
          >{{ formFields.genericErrors.required.message }}</span
        >
        <span
          class="field-validation-error"
          *ngIf="approvalCode.errors?.pattern"
          >{{ formFields.genericErrors.onlyNumbersValidation.message }}</span
        >
        <span
          class="field-validation-error"
          *ngIf="approvalCode.errors?.approvalCodeError"
          >{{ approvalCodeErrorMessage }}</span
        >
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions>
  <ng-container *ngIf="data.fields.SubmitButtonLabel.value !== ''">
    <button
      class="btn btn-primary btn-mid btn-block btn-md-block-none"
      abButtonLoader
      [disabled]="approvalForm.invalid"
      (click)="confirm()"
    >
      <span *scText="data.fields.SubmitButtonLabel"></span>
    </button>
  </ng-container>
  <ng-container *ngIf="data.fields.CancelButtonLabel.value !== ''">
    <button
      class="btn btn-link btn-with-icon btn-block btn-md-block-none"
      (click)="dialogRef.close()"
    >
      <span *scText="data.fields.CancelButtonLabel"></span>
    </button>
  </ng-container>
</div>
